// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__EhJAv","spinner":"MGLoader_spinner__b7RI9","mg-loader-spin":"MGLoader_mg-loader-spin__RfLQT"};